import { render, staticRenderFns } from "./PodrList.vue?vue&type=template&id=391aa248&scoped=true&"
import script from "./PodrList.vue?vue&type=script&lang=js&"
export * from "./PodrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391aa248",
  null
  
)

export default component.exports